import { useState } from "react"
import Button from "../ui/Button"
import FormInput from "../ui/FormInput"
import FormSection from "../ui/FormSection"
import MilestoneTable from "../ui/MilestoneTable"
import Modal from "../ui/Modal"
import CustomCheckbox from "../ui/CustomCheckbox"
import { useNavigate } from "react-router-dom"
import State, { STATE, CurrentEntityState, CurrentStudyState } from "@state";
import { v4 as uuidv4 } from "uuid";
import StudyController from "@/network/controllers/study.controller";

export default function StudySettings({ onNext }) {
  const initialLocalData = {
    tmpId: "",
    name: STATE[CurrentStudyState.STUDY].name,
    estimatedDuration: STATE[CurrentStudyState.STUDY].estimatedDuration,
    thresholdOfParticipants: STATE[CurrentStudyState.STUDY].thresholdOfParticipants,
    masterIcfs: STATE[CurrentStudyState.MASTER_ICFS],
    milestones: STATE[CurrentStudyState.MILESTONES],
    sites: STATE[CurrentStudyState.SITES],
    studyManagers: STATE[CurrentStudyState.CRO_MANAGERS],
    investigators: STATE[CurrentStudyState.INVESTIGATORS],
    masterIcfName: "",
    newMilestone: {
      name: "",
      description: "",
      mandatory: false,
    },
  }

  const [localData, setLocalData] = useState(initialLocalData)
  const [masterIcfs, setMasterIcfs] = useState(initialLocalData.masterIcfs || [])
  const [milestones, setMilestones] = useState(initialLocalData.milestones || [])
  const [isProcessing, setIsProcessing] = useState(false)
  const [modalMessage, setModalMessage] = useState("")
  const [showStudySetupModal, setShowStudySetupModal] = useState(false)
  const navigate = useNavigate()

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setLocalData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleMasterICFInputChange = (e) => {
    const { value } = e.target
    setLocalData((prev) => ({
      ...prev,
      masterIcfName: value,
    }))

    handleAddMasterIcf(value);
  }



  const handleMilestoneInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setLocalData((prev) => ({
      ...prev,
      newMilestone: {
        ...prev.newMilestone,
        [name]: type === "checkbox" ? checked : value,
      },
    }))
  }

  const handleCheckboxChange = (isChecked) => {
    setLocalData((prev) => ({
      ...prev,
      newMilestone: {
        ...prev.newMilestone,
        mandatory: isChecked,
      },
    }))
  }

  const handleAddMasterIcf = (name) => {

    if (name?.trim()) {
      const newMasterIcf = {
        ...CurrentStudyState.MODELS.masterIcfModel,
        tmpId: uuidv4(),
        name: name,
      }

      setMasterIcfs((prev) => [newMasterIcf])


    }
  }

  const handleAddMilestone = () => {
    if (localData.newMilestone.name.trim() && localData.newMilestone.description.trim()) {
      const newMilestone = {
        ...CurrentStudyState.MODELS.milestoneModel,
        tmpId: uuidv4(),
        masterIcfId: masterIcfs?.[0]?.tmpId||"",
        number: milestones.length + 1,
        name: localData.newMilestone.name,
        description: localData.newMilestone.description,
        mandatory: localData.newMilestone.mandatory,
      }
      setMilestones((prev) => [...prev, newMilestone])
      setLocalData((prev) => ({
        ...prev,
        newMilestone: {
          name: "",
          description: "",
          mandatory: false,
        },
      }))
    }
  }

  const handleEditMilestone = (updatedMilestone) => {
    if (Array.isArray(updatedMilestone)) {
      setMilestones(updatedMilestone)
    } else {
      setMilestones((prev) => prev.map((m) => (m.tmpId === updatedMilestone.tmpId ? updatedMilestone : m)))
    }
  }

  const handleDeleteMilestone = (milestone) => {
    setMilestones((prev) => {
      const filtered = prev.filter((m) => m.tmpId !== milestone.tmpId)
      return filtered.map((m, index) => ({
        ...m,
        number: index + 1,
      }))
    })
  }

  const handleValidatingChange = (milestoneId, isChecked) => {
    setMilestones((prev) =>
      prev.map((milestone) => (milestone.tmpId === milestoneId ? { ...milestone, mandatory: isChecked } : milestone)),
    )
  }

  const handleReorderMilestones = (oldIndex, newIndex) => {
    setMilestones((prev) => {
      const result = Array.from(prev)
      const [removed] = result.splice(oldIndex, 1)
      result.splice(newIndex, 0, removed)
      return result.map((milestone, index) => ({
        ...milestone,
        number: index + 1,
      }))
    })
  }

  

    // ==== ANCIEN CODE ======
  const handleContinue = () => {
    handleAddMasterIcf(localData.masterIcfName);
    State.setValue(CurrentStudyState.MASTER_ICFS, masterIcfs)
    State.setValue(CurrentStudyState.MILESTONES, milestones)  
    State.setValue(CurrentStudyState.STUDY, {
      name: localData.name,
      estimatedDuration: localData.estimatedDuration,
      thresholdOfParticipants: localData.thresholdOfParticipants,
      masterIcfs: masterIcfs,
      milestones: milestones,
    })

    console.log('=== STATE === StudySettings.jsx === key: 888476 ===');
    console.dir(STATE, { depth: null, colors: true })
    console.log('=================================');
    
    //
    handleRegisterStudy();
    

  }

  const handleRegisterStudy = async () => {
    
    const resp = await StudyController.registerStudy()

    console.log('=== resp === StudySettings.jsx === key: 213985 ===');
    console.dir(resp, { depth: null, colors: true })
    console.log('=================================');



    if (resp?.success!==false) {
      setShowStudySetupModal(true)
    }
  }

  const handleCompleteSetupLater = () => {
    return;
    setShowStudySetupModal(false)
    setTimeout(() => {
      navigate("/dashboard")
    }, 100)
  }

  const handleContinueSetup = () => {
    setShowStudySetupModal(false)
    onNext()
  }

  // Simple responsive tooltip that never overflows the viewport
  const InfoTooltip = ({ text }) => {
    const [isVisible, setIsVisible] = useState(false)
    return (
      <div className="relative inline-block align-middle">
        <img
          src="/icons/study/Info.svg"
          alt="Info"
          className="h-5 w-5 cursor-help shrink-0"
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
          onError={(e) => { e.target.onerror = null; e.target.style.display = 'none' }}
        />
        {isVisible && (
          <div
            className="
              absolute z-50 w-64 rounded border border-gray-200 bg-white p-2 text-sm text-gray-700 shadow-lg
              left-1/2 -translate-x-1/2 mt-2   /* center on small */
              sm:left-auto sm:right-0 sm:translate-x-0 /* align right on ≥sm */
            ">
            {text}
          </div>
        )}
      </div>
    )
  }

  console.log("Statut du jalon avant le rendu du tableau", milestones);
  return (
    <div className="pb-4">
      {/* Study Settings Section */}
      <FormSection title="Study settings">
        {/* Use flexible grid; keep colors; ensure text doesn't push out */}
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 min-w-0">
          <div className="min-w-0">
            <label className="mb-1 block text-sm font-medium text-gray-700">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="min-w-0 break-words">Name</span>
                <InfoTooltip text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." />
              </div>
            </label>
            <input
              type="text"
              name="name"
              value={localData.name}
              onChange={handleInputChange}
              placeholder="Study name"
              className="w-full min-w-0 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
            />
          </div>

          <div className="min-w-0">
            <label className="mb-1 block text-sm font-medium text-gray-700">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="min-w-0 break-words">Estimated patient participation duration</span>
                <InfoTooltip text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." />
              </div>
            </label>
            <input
              type="text"
              name="estimatedDuration"
              value={localData.estimatedDuration}
              onChange={handleInputChange}
              placeholder="In days, months, years, ..."
              className="w-full min-w-0 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
            />
          </div>

          <div className="min-w-0">
            <label className="mb-1 block text-sm font-medium text-gray-700">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="min-w-0 break-words">Threshold of consenting participants</span>
                <InfoTooltip text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." />
              </div>
            </label>
            <input
              type="text"
              name="thresholdOfParticipants"
              value={localData.thresholdOfParticipants}
              onChange={handleInputChange}
              placeholder="Text"
              className="w-full min-w-0 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
            />
          </div>
        </div>
      </FormSection>

      {/* Master ICF Section */}
      <div className="grid grid-cols-1 gap-4">
        <FormSection title="Master ICF" subtitle="Add version" compact={false}>
          {/* Ensure button/input wrap instead of overflowing */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
            <div className="flex-1 min-w-0">
              <input
                type="text"
                name="masterIcfName"
                value={localData.masterIcfName}
                onChange={handleMasterICFInputChange}
                placeholder="Master ICF version name"
                className={`w-full min-w-0 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF] ${
                  masterIcfs.length > 0 ? "bg-gray-300" : ""
                }`}
              />
            </div>
          
            {/* <Button className="w-full sm:w-auto" variant="addbutton">Add / Edit</Button> */}
          </div>
        </FormSection>
      </div>

      {/* Milestones Settings Section */}
      <FormSection title="Milestones settings">
        {/* Table wrapper to avoid horizontal cut on small screens */}
        <div className="mb-6 -mx-2 sm:mx-0">
        <div className="overflow-x-auto px-3 sm:px-0" style={{ scrollbarGutter: "stable both-edges" }}>
        <div className="min-w-[1120px] sm:min-w-[1120px] md:min-w-[1180px]">
              <MilestoneTable
                milestones={milestones}
                onEdit={{ multiple: handleEditMilestone }}
                onDelete={handleDeleteMilestone}
                onValidatingChange={handleValidatingChange}
                onReorder={handleReorderMilestones}
              />
            </div>
          </div>
        </div>

        {/* Add New Milestone Form */}
        <h3 className="mb-4 text-lg font-semibold">Add milestone</h3>
        <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-6">
          <div className="lg:col-span-4 min-w-0">
            <FormInput
              label="Milestone name"
              name="name"
              value={localData.newMilestone.name}
              onChange={handleMilestoneInputChange}
              placeholder="Ex: Baseline assessment, First treatment administration"
              inputClassName="h-10"
            />
          </div>
          <div className="lg:col-span-4 min-w-0">
            <FormInput
              label="Milestone description"
              name="description"
              value={localData.newMilestone.description}
              onChange={handleMilestoneInputChange}
              placeholder="Ex: First dose administered according to the protocol"
              inputClassName="h-10"
            />
          </div>
          <div className="lg:col-span-2 flex flex-col">
            <label htmlFor="mandatory" className="mb-2 block text-center text-sm font-medium text-gray-700">
              Validating milestone
            </label>
            <div className="flex h-10 items-center justify-center pt-1">
              <CustomCheckbox checked={localData.newMilestone.mandatory} onChange={handleCheckboxChange} />
            </div>
          </div>
          <div className="lg:col-span-2 flex flex-col">
            <div className="mb-2 h-2">&nbsp;</div>
            <div className="flex h-12 items-center justify-end">
              <Button onClick={handleAddMilestone} variant="addbutton" className="w-full sm:w-auto">
                Add milestone
              </Button>
            </div>
          </div>
        </div>
      </FormSection>

      <div className="h-6" />

      {/* Continue Button */}
      <div className="mt-10 flex justify-end">
        <Button onClick={handleContinue} variant="sidebarbutton" className="w-full sm:w-auto px-6 py-2">
          Continue
        </Button>
      </div>

      <Modal
        isOpen={showStudySetupModal}
        onClose={handleContinueSetup}
        title="Study setup"
        primaryAction={handleContinueSetup}
        primaryActionLabel="Continue setup"
        size="xl"
      >
        <p className="mb-4">You have successfully initiated the study.</p>
        <p className="mb-4">
          Would you like to continue setting up the study now by adding the study sites and inviting additional Study
          Managers, as well as Investigators (physicians) to conduct the study?
        </p>
        <p className="mb-4">Or would you prefer to complete this step later?</p>
      </Modal>

      {/* Loading Modal */}
      <Modal isOpen={isProcessing} onClose={() => {}} title="Please wait…" hideCloseButton size="md">
        <div className="flex flex-col items-center gap-4 p-6">
          <svg className="h-8 w-8 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="text-center">{modalMessage}</p>
        </div>
      </Modal>
    </div>
  )
}